import { type CreateBlockData } from '@/lib/builder/types'

import {
  type ScrollingSection,
  type ScrollingSectionCreate,
} from '../../../WebsiteBuilder.types'

export const createScrollingData = ({
  brandId,
}: CreateBlockData<ScrollingSection>): ScrollingSectionCreate => ({
  brandId,
  params: {
    background: {
      params: { token: 'black' },
      type: 'color',
    },
    items: [],
  },
  type: 'scrolling',
})
